import { Component } from "@angular/core";
import { AuthService } from "../../../../core/services/auth.service";
import { Router } from "@angular/router";

@Component({
    selector: "app-modal-bienvenida",
    imports: [],
    templateUrl: "./modal-bienvenida.component.html",
    styleUrl: "./modal-bienvenida.component.css"
})
export class ModalBienvenidaComponent {
  constructor(
    public authService: AuthService,
    private router: Router,
  ) { }

  cerrarModal(): void {
    this.authService.modalBienvenida.set(false);
  }

  redirigirAHabilitarFacturacion(): void {
    this.cerrarModal()
    this.router.navigate(["dashboard/facturacion/habilitar-facturacion"]);
  }
}
